import React from 'react';
import Layout from './Layout';
import Table from './Table';

import './Whitelist.css';

export default () => {
  return (
    <Layout>
      <Table />
    </Layout>
  );
};